export const IGetLocaleUseCaseType = Symbol('IGetLocaleUseCase');
